const { componentList } = require('../config');

async function onDomLoad() {
    // Common component onDomLoad
    await Promise.all(
        componentList.filter((component) => component.loadType === 'onDomLoad')
            .map(async (obj) => {
                if (document.querySelectorAll(obj.queryString).length) {
                    await import(/* webpackChunkName: '[request]' */ `./${obj.name}/index`);
                }
            }),
    );
}

async function onWindowLoad() {
    // Common component onWindowLoad
    await Promise.all(
        componentList.filter((component) => component.loadType === 'onWindowLoad')
            .map(async (obj) => {
                if (document.querySelectorAll(obj.queryString).length) {
                    await import(/* webpackChunkName: '[request]' */ `./${obj.name}/index`);
                }
            }),
    );
}

document.addEventListener('DOMContentLoaded', () => {
    onDomLoad();
});

window.addEventListener('load', () => {
    onWindowLoad();
});
